import React, { useRef, useState } from 'react';

import { ContainedButton, OutlinedButton } from '../../modules/Buttons';
import Modal from '../../modules/Modal';
import { useAppDispatch } from '../../../store/hooks';
import { deleteFolderByIdFromAllContentPage } from '../../../api/foldersApi';
import styles from './DeleteFolderModal.module.scss';
import { deleteComposerById, getUserOrganization } from '../../../api';
import { saveMyOrganization } from '../../../store/user/userSlice';
import { USER } from '../../../enums';
import { useHotkeys } from 'react-hotkeys-hook';

type TDeleteFolderModal = {
  open: boolean;
  switchModal: () => void;
  folderId: string;
  owner: any;
  fetchDataCallback?: () => void;
};

const DeleteComposer: React.FC<TDeleteFolderModal> = ({ open, switchModal, folderId, owner, fetchDataCallback }) => {
  const [loading, setLoading] = useState(false);
  const submitButtonRef = useRef<HTMLDivElement>(null);
  const onModalClose = () => {
    switchModal();
  };
  const dispatch = useAppDispatch();

  const handleDelete = async () => {
    setLoading(true);
    try {
      await deleteComposerById({ videofeedId: folderId });
      if (fetchDataCallback) {
        fetchDataCallback();
      }
      getUserOrganization()
        .then((resp) => {
          dispatch(saveMyOrganization(resp.data));
        })
        .catch((error) => console.error(error));
    } catch (err) {
      console.log(err);
      // @ts-ignore
      if (err?.response?.data?.message) {
        // @ts-ignore
        notification.showMessage(err?.response?.data?.message);
      }
    } finally {
      onModalClose();
      setLoading(false);
    }
  };

  useHotkeys('Enter', () => {
    if (open && !loading) submitButtonRef?.current?.click();
  });

  return (
    <Modal open={open} onClose={onModalClose} loading={loading}>
      <div className={styles.modalBody}>
        <div className={styles.modalTitle}>Are you sure you want to delete {owner?.username || owner?.email}'s content?</div>
        <div className={styles.form}>
          <div className={styles.actionBtns}>
            <OutlinedButton onClick={handleDelete} kind="default">
              <div ref={submitButtonRef}>Yes, I am sure</div>
            </OutlinedButton>

            <ContainedButton kind="purple" onClick={onModalClose}>
              No, cancel
            </ContainedButton>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteComposer;
